module.exports = __webpack_public_path__ + "static/img/qywxqrcode.4e2bdb2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qywxqrcode.png
// module id = 0MN6
// module chunks = 30